/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var PLATFORM_WITH_REVIEWS;
(function (PLATFORM_WITH_REVIEWS) {
    PLATFORM_WITH_REVIEWS["UBER_EATS"] = "UberEats";
    PLATFORM_WITH_REVIEWS["DOORDASH"] = "Doordash";
    PLATFORM_WITH_REVIEWS["GRUBHUB"] = "Grubhub";
    PLATFORM_WITH_REVIEWS["HELPSCOUT"] = "Helpscout";
})(PLATFORM_WITH_REVIEWS || (PLATFORM_WITH_REVIEWS = {}));
